// extracted by extract-css-chunks-webpack-plugin
module.exports = {"label":"label--[Frida]_Ox61","form-control":"form-control--[Frida]_xvMy","active":"active--[Frida]_EhFN"};